import { Box, Grid, Grid2, IconButton, Typography } from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { formatExperience } from "../../utils/CommonFunctions";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import BusinessSharpIcon from "@mui/icons-material/BusinessSharp";
import { Tooltip } from "@mui/material";
import { ReactComponent as ProfileIcon } from "../animations/profilenew.svg";
import { ReactComponent as ResumeIcon } from "../animations/resumenew.svg";
import { ReactComponent as GearIcon } from "../animations/gear.svg";
import { Chip } from "@mui/material";
import EngineeringIcon from "@mui/icons-material/Engineering";
import useIsMobile from "../../hooks/useIsMobile";

function CollapsibleTableNew({
  rows,
  searchQuery,
  page,
  rowsPerPage,
  tableLoading,
  collapsible,
  tableName,
}) {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const [openRowId, setOpenRowId] = useState(null);
  const [openSkill, setOpenSkill] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [paginatedRows, setPaginatedRows] = useState([]);
  const apiRef = useGridApiRef();

  const getStatusChip = (fitCategory, percentage) => {
    let color = "";
    let label = "";

    if (fitCategory === "EXACT FIT") {
      color = "#2BB344";
      label = `Fit (${percentage}%)`;
    } else if (fitCategory === "PARTIAL FIT") {
      color = "#FFC218";
      label = `Partial Fit (${percentage}%)`;
    } else if (fitCategory === "UNFIT") {
      color = "#E0011C";
      label = `Unfit (${percentage}%)`;
    } else if (fitCategory === "LESS OPTIMUM FIT") {
      color = "#0BA2FF";
      label = `LESS OPTIMUM FIT (${percentage}%)`;
    }

    return (
      <Chip
        label={label}
        sx={{
          fontFamily: "Poppins",
          backgroundColor: color,
          color: "#FFFFFF",
          fontWeight: 600,
          fontSize: "12px",
          lineHeight: 18,
          borderRadius: "4px",
          ml: 1,
        }}
        size="small"
      />
    );
  };

  useEffect(() => {
    const start = currentPage * rowsPerPage;
    const end = start + rowsPerPage;
    setPaginatedRows(rows.slice(start, end));
  }, [currentPage, rows]);

  const iconStyle = {
    width: "50px",
    height: "50px",
    borderRadius: "8px",
  };

  const renderStatusIcon = (row) => {
    if (row.evaluationTested)
      return (
        <img
          src="/assets/images/peerreviewed.svg"
          alt="Peer Reviewed"
          style={iconStyle}
        />
      );
    if (row.selfAttested)
      return (
        <img
          src="/assets/images/SELF-ATTESTED.svg"
          alt="Self Attested"
          style={iconStyle}
        />
      );
    if (row.resumeParsed)
      return (
        <img
          src="/assets/images/ResumeBased.svg"
          alt="Resume Based"
          style={iconStyle}
        />
      );
    return (
      <img
        src="/assets/images/ResumeBased.svg"
        alt="Resume Based"
        style={iconStyle}
      />
    );
  };

  const formatISTDateTime = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };

  function InfoRow({ icon, label }) {
    return (
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}
      >
        {icon}
        <Typography
          variant="body2"
          sx={{
            color: "#FDF9E0B2",
            wordBreak: "break-word",
            whiteSpace: "normal",
            flex: 1,
          }}
        >
          {label}
        </Typography>
      </Box>
    );
  }

function highlightText(text, searchQuery) {
  if (!searchQuery || typeof text !== "string") return text;

  // Split searchQuery by comma, trim spaces, and escape regex special chars
  const terms = searchQuery
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean)
    .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  if (terms.length === 0) return text;

  // Build regex for all terms, case-insensitive, global
  const regex = new RegExp(`(${terms.join("|")})`, "gi");

  // Use .split() and .map(), but do NOT use regex.test() inside map (it advances regex state)
  return text.split(regex).map((part, index) =>
    terms.some(term => part.toLowerCase() === term.toLowerCase()) ? (
      <span key={index} style={{ backgroundColor: "yellow", color: "black" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
}
  const ChildRowsLayoutMobileView = ({ children, isOpen }) => (
    <Box sx={{ mt: 0, pl: 0, pb: 1, mb: 1 }}>
      {children.map((row, index) => {
        const showSkills = openSkill === row.uuid;
        const allSkills = row.userform?.primarySkill?.map(
          (skill) => skill.name
        );
        const visibleSkills = showSkills ? allSkills : allSkills.slice(0, 5);
        const showFields = tableName === "jd-ranker" ? true : false;
        return (
          <Box
            sx={{
              borderLeft: "1px solid #FDF9E0",
              borderBottom:
                children.length == index + 1 ? "none" : "1px solid #FDF9E0",
              color: "#FDF9E0",
              gap: 2,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              padding: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              {" "}
              <Box sx={{ display: "flex", gap: 3 }}>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#FDF9E0" }}
                  >
                    {highlightText(row.name, searchQuery)}
                  </Typography>
                </Box>
                {showFields && (
                  <Box>
                    {" "}
                    {getStatusChip(row?.fitCategory, row?.fitPercentage)}
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Tooltip title="View Resume">
                  <IconButton
                    component="a"
                    href={row.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#FDF9E0",
                      backgroundColor: "#0BA2FF",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#0BA2FF",
                      },
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <div
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "8px",
                      }}
                    >
                      <ResumeIcon />
                    </div>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Public Profile">
                  <IconButton
                    component="a"
                    href={`/resume-history/${row.uuid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#FDF9E0",
                      backgroundColor: "#26801E",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "#26801E",
                      },
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <div
                      style={{
                        height: "30px",
                        width: "30px",
                        borderRadius: "8px",
                      }}
                    >
                      <ProfileIcon />
                    </div>
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box>
                <InfoRow
                  icon={<PhoneInTalkOutlinedIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.mobile || "N/A",
                    searchQuery
                  )}
                />
              </Box>
              <Box>
                <InfoRow
                  icon={
                    <CalendarMonthOutlinedIcon sx={{ color: "#FDF9E0B2" }} />
                  }
                  label={highlightText(
                    formatISTDateTime(row.time || row.date) || "N/A",
                    searchQuery
                  )}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box>
                {" "}
                <InfoRow
                  icon={<EmailOutlinedIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.email || "N/A",
                    searchQuery
                  )}
                />
              </Box>
              <Box>
                {" "}
                <InfoRow
                  icon={<BusinessSharpIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.currentCompany || "N/A",
                    searchQuery
                  )}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box>
                <InfoRow
                  icon={<LocationOnOutlinedIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.location || "N/A",
                    searchQuery
                  )}
                />
              </Box>
              <Box>
                {" "}
                <InfoRow
                  icon={<GearIcon />}
                  label={highlightText(
                    row.userform?.role || "N/A",
                    searchQuery
                  )}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 0,
                  }}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#FDF9E0",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {isNaN(row.userform?.experience)
                        ? `Total experience of ${row.userform?.experience}`
                        : formatExperience(
                            parseInt(row.userform?.experience, 10)
                          )}{" "}
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#FDF9E0B2",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    Years of Experience
                  </Typography>
                </Box>{" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      maxWidth: "100%",
                    }}
                  >
                    {visibleSkills?.map((skill, index) => (
                      <Chip
                        key={index}
                        label={highlightText(skill, searchQuery)}
                        size="small"
                        variant="outlined"
                        sx={{
                          color: "#FDF9E0",
                          backgroundColor: "#1e1e1e",
                          fontWeight: 500,
                          fontSize: "12px",
                          lineHeight: "18px",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          border: "0.2px solid #FDF9E0",
                          maxWidth: "100%",
                          whiteSpace: "normal",
                        }}
                      />
                    ))}

                    {allSkills?.length > 5 && (
                      <IconButton
                        onClick={() =>
                          setOpenSkill(showSkills ? null : row.uuid)
                        }
                        sx={{
                          color: "#FDF9E0",
                        }}
                      >
                        {showSkills ? (
                          // <KeyboardArrowUpIcon fontSize="small" />
                          <span style={{ fontSize: "12px" }}>View less...</span>
                        ) : (
                          // <KeyboardArrowDownIcon fontSize="small" />
                          <span style={{ fontSize: "12px" }}>View more...</span>
                        )}
                      </IconButton>
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#FDF9E0B2",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    Skills
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                  }}
                >
                  <Box>{renderStatusIcon(row)}</Box>
                </Box>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: "#FDF9E0B2", textAlign: "left" }}
                  >
                    Status
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
  const ChildRowsLayout = ({ children }) => (
    <Box sx={{ mt: 0, pl: 0, pb: 1, mb: 1 }}>
      {children.map((row, index) => {
        const showSkills = openSkill === row.uuid;
        const allSkills = row.userform?.primarySkill?.map(
          (skill) => skill.name
        );
        const visibleSkills = showSkills ? allSkills : allSkills.slice(0, 5);
        const showFields = tableName === "jd-ranker" ? true : false;
        return (
          <Grid2
            container
            spacing={2}
            mb={0}
            p={1.5}
            sx={{
              borderLeft: "1px solid #FDF9E0",
              borderBottom:
                children.length == index + 1 ? "none" : "1px solid #FDF9E0",
            }}
          >
            <Grid2 item size={{ xs: 11 }}>
              <Grid2 container spacing={2} sx={{ alignItems: "flex-start" }}>
                <Grid2
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 0.5,
                    }}
                  >
                    <Grid2 container spacing={1} sx={{ width: "100%" }}>
                      <Grid2
                        item
                        size={{
                          xs: 12,
                          sm: showFields ? 6 : 12,
                          md: showFields ? 6 : 12,
                          lg: showFields ? 6 : 12,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", color: "#FDF9E0" }}
                        >
                          {highlightText(row.name, searchQuery)}
                        </Typography>
                      </Grid2>
                      {showFields && (
                        <Grid2
                          item
                          size={{
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                          }}
                          sx={{
                            display: "flex",
                            justifyContent: {
                              xs: "flex-start",
                              sm: "flex-end",
                              ml: 0,
                            },
                          }}
                        >
                          {getStatusChip(row?.fitCategory, row?.fitPercentage)}
                        </Grid2>
                      )}
                    </Grid2>

                    <Box>
                      <Tooltip title={"Mobile Number"} arrow>
                        <Box>
                          <InfoRow
                            icon={
                              <PhoneInTalkOutlinedIcon
                                sx={{ color: "#FDF9E0B2" }}
                              />
                            }
                            label={highlightText(
                              row.userform?.mobile || "N/A",
                              searchQuery
                            )}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                    <Box>
                      <Tooltip title={"Email Address"} arrow>
                        <Box>
                          <InfoRow
                            icon={
                              <EmailOutlinedIcon sx={{ color: "#FDF9E0B2" }} />
                            }
                            label={highlightText(
                              row.userform?.email || "N/A",
                              searchQuery
                            )}
                          />{" "}
                        </Box>
                      </Tooltip>
                    </Box>
                    <Box>
                      <Tooltip title={"Location"} arrow>
                        <Box>
                          <InfoRow
                            icon={
                              <LocationOnOutlinedIcon
                                sx={{ color: "#FDF9E0B2" }}
                              />
                            }
                            label={highlightText(
                              row.userform?.location || "N/A",
                              searchQuery
                            )}
                          />{" "}
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-end",
                      gap: 1,
                    }}
                  >
                    <Box>
                      <Tooltip title={"Date & Time"} arrow>
                        <Box>
                          <InfoRow
                            icon={
                              <CalendarMonthOutlinedIcon
                                sx={{ color: "#FDF9E0B2" }}
                              />
                            }
                            label={highlightText(
                              formatISTDateTime(row.time || row.date) || "N/A",
                              searchQuery
                            )}
                          />
                        </Box>
                      </Tooltip>
                    </Box>

                    <Box>
                      <Tooltip title={"Last Company"} arrow>
                        <Box>
                          <InfoRow
                            icon={
                              <BusinessSharpIcon sx={{ color: "#FDF9E0B2" }} />
                            }
                            label={highlightText(
                              row.userform?.currentCompany || "N/A",
                              searchQuery
                            )}
                          />
                        </Box>
                      </Tooltip>
                    </Box>

                    <Box>
                      <Tooltip title={"Last Role"} arrow>
                        <Box>
                          <InfoRow
                            icon={<GearIcon />}
                            label={highlightText(
                              row.userform?.role || "N/A",
                              searchQuery
                            )}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 4,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "left",
                      }}
                    >
                      <Box>{renderStatusIcon(row)}</Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="caption"
                        sx={{ color: "#FDF9E0B2", textAlign: "left" }}
                      >
                        Status
                      </Typography>
                    </Box>
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#FDF9E0",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {isNaN(row.userform?.experience)
                          ? `Total experience of ${row.userform?.experience}`
                          : formatExperience(
                              parseInt(row.userform?.experience, 10)
                            )}{" "}
                      </Typography>
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#FDF9E0B2",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      Years of Experience
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 3,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        maxWidth: "100%",
                      }}
                    >
                      {visibleSkills.map((skill, index) => (
                        <Chip
                          key={index}
                          label={skill}
                          size="small"
                          variant="outlined"
                          sx={{
                            color: "#FDF9E0",
                            backgroundColor: "#1e1e1e",
                            fontWeight: 500,
                            fontSize: "12px",
                            lineHeight: "18px",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            border: "0.2px solid #FDF9E0",
                            maxWidth: "100%",
                            whiteSpace: "normal",
                          }}
                        />
                      ))}

                      {allSkills.length > 5 && (
                        <IconButton
                          onClick={() =>
                            setOpenSkill(showSkills ? null : row.uuid)
                          }
                          sx={{
                            color: "#FDF9E0",
                          }}
                        >
                          {showSkills ? (
                            // <KeyboardArrowUpIcon fontSize="small" />
                            <span style={{ fontSize: "12px" }}>
                              View less...
                            </span>
                          ) : (
                            // <KeyboardArrowDownIcon fontSize="small" />
                            <span style={{ fontSize: "12px" }}>
                              View more...
                            </span>
                          )}
                        </IconButton>
                      )}
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#FDF9E0B2",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      Skills
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2 item size={{ xs: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  alignItems: "center",
                }}
              >
                <Tooltip title="View Resume1">
                  <IconButton
                    component="a"
                    href={row.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#FDF9E0",
                      backgroundColor: "#0BA2FF",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#0BA2FF",
                      },
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <div
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "8px",
                      }}
                    >
                      <ResumeIcon />
                    </div>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Public Profile">
                  <IconButton
                    component="a"
                    href={`/resume-history/${row.uuid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#FDF9E0",
                      backgroundColor: "#26801E",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "#26801E",
                      },
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <div
                      style={{
                        height: "30px",
                        width: "30px",
                        borderRadius: "8px",
                      }}
                    >
                      <ProfileIcon />
                    </div>
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid2>
          </Grid2>
        );
      })}
    </Box>
  );
  const MobileView = (
    row,
    isOpen,
    showSkills,
    visibleSkills,
    showFields,
    allSkills
  ) => {
    return (
      <Box sx={{ width: "100%", p: 2, pl: 0, pr: 0, display: "flex", m: 0 }}>
        {collapsible && (
          <Box>
            {" "}
            {row.group && row.group.length > 0 ? (
              <IconButton
                onClick={() => setOpenRowId(isOpen ? null : row.uuid)}
                sx={{ color: "#FDF9E0" }}
              >
                {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            ) : (
              <IconButton
                disabled
                onClick={() => setOpen(!open)}
                sx={{ color: "#FDF9E0" }}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            )}
            {row.group?.length > 0 && (
              <Box
                sx={{
                  backgroundColor: "#FFC218",
                  height: "30px",
                  width: "21px",
                  border: "1px solid #FDF9E0",
                  borderRadius: "6px",
                  justifySelf: "center",
                }}
              >
                <div
                  style={{
                    height: "28px",
                    width: "11px",
                    lineHeight: "28px",
                    font: "Poppins",
                    fontWeight: "600",
                    color: "#000000",
                    padding: "2px 4px",
                  }}
                >
                  {row.group?.length + 1}
                </div>
              </Box>
            )}
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <Box
            sx={{
              borderLeft: isOpen ? "1px solid #FDF9E0" : "none",
              borderBottom: isOpen ? "1px solid #FDF9E0" : "none",
              color: "#FDF9E0",
              gap: 2,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              padding: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              {" "}
              <Box sx={{ display: "flex", gap: 3 }}>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#FDF9E0" }}
                  >
                    {highlightText(row.name, searchQuery)}
                  </Typography>
                </Box>
                {showFields && (
                  <Box>
                    {" "}
                    {getStatusChip(row?.fitCategory, row?.fitPercentage)}
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Tooltip title="View Resume">
                  <IconButton
                    component="a"
                    href={row.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#FDF9E0",
                      backgroundColor: "#0BA2FF",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#0BA2FF",
                      },
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <div
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "8px",
                      }}
                    >
                      <ResumeIcon />
                    </div>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Public Profile">
                  <IconButton
                    component="a"
                    href={`/resume-history/${row.uuid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#FDF9E0",
                      backgroundColor: "#26801E",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "#26801E",
                      },
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <div
                      style={{
                        height: "30px",
                        width: "30px",
                        borderRadius: "8px",
                      }}
                    >
                      <ProfileIcon />
                    </div>
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box>
                <InfoRow
                  icon={<PhoneInTalkOutlinedIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.mobile || "N/A",
                    searchQuery
                  )}
                />
              </Box>
              <Box>
                <InfoRow
                  icon={
                    <CalendarMonthOutlinedIcon sx={{ color: "#FDF9E0B2" }} />
                  }
                  label={highlightText(
                    formatISTDateTime(row.time || row.date) || "N/A",
                    searchQuery
                  )}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box>
                {" "}
                <InfoRow
                  icon={<EmailOutlinedIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.email || "N/A",
                    searchQuery
                  )}
                />
              </Box>
              <Box>
                {" "}
                <InfoRow
                  icon={<BusinessSharpIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.currentCompany || "N/A",
                    searchQuery
                  )}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box>
                <InfoRow
                  icon={<LocationOnOutlinedIcon sx={{ color: "#FDF9E0B2" }} />}
                  label={highlightText(
                    row.userform?.location || "N/A",
                    searchQuery
                  )}
                />
              </Box>
              <Box>
                {" "}
                <InfoRow
                  icon={<GearIcon />}
                  label={highlightText(
                    row.userform?.role || "N/A",
                    searchQuery
                  )}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 0,
                  }}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#FDF9E0",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {isNaN(row.userform?.experience)
                        ? `Total experience of ${row.userform?.experience}`
                        : formatExperience(
                            parseInt(row.userform?.experience, 10)
                          )}{" "}
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#FDF9E0B2",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    Years of Experience
                  </Typography>
                </Box>{" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      maxWidth: "100%",
                    }}
                  >
                    {visibleSkills?.map((skill, index) => (
                      <Chip
                        key={index}
                        label={highlightText(skill, searchQuery)}
                        size="small"
                        variant="outlined"
                        sx={{
                          color: "#FDF9E0",
                          backgroundColor: "#1e1e1e",
                          fontWeight: 500,
                          fontSize: "12px",
                          lineHeight: "18px",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          border: "0.2px solid #FDF9E0",
                          maxWidth: "100%",
                          whiteSpace: "normal",
                        }}
                      />
                    ))}

                    {allSkills?.length > 5 && (
                      <IconButton
                        onClick={() =>
                          setOpenSkill(showSkills ? null : row.uuid)
                        }
                        sx={{
                          color: "#FDF9E0",
                        }}
                      >
                        {showSkills ? (
                          // <KeyboardArrowUpIcon fontSize="small" />
                          <span style={{ fontSize: "12px" }}>View less...</span>
                        ) : (
                          // <KeyboardArrowDownIcon fontSize="small" />
                          <span style={{ fontSize: "12px" }}>View more...</span>
                        )}
                      </IconButton>
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#FDF9E0B2",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    Skills
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                  }}
                >
                  <Box>{renderStatusIcon(row)}</Box>
                </Box>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: "#FDF9E0B2", textAlign: "left" }}
                  >
                    Status
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box>
            {isOpen && row.group?.length > 0 && (
              <ChildRowsLayoutMobileView
                children={row.group}
                searchQuery={searchQuery}
                isOpen={isOpen}
              />
            )}
          </Box>
        </Box>
      </Box>
    );
  };
  const NormalView = (
    row,
    isOpen,
    showSkills,
    visibleSkills,
    showFields,
    allSkills
  ) => {
    return (
      <Box sx={{ width: "100%", p: 2, pl: 0, pr: 3, display: "flex", m: 0 }}>
        {collapsible && (
          <Box>
            {" "}
            {row.group && row.group.length > 0 ? (
              <IconButton
                onClick={() => setOpenRowId(isOpen ? null : row.uuid)}
                sx={{ color: "#FDF9E0" }}
              >
                {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            ) : (
              <IconButton
                disabled
                onClick={() => setOpen(!open)}
                sx={{ color: "#FDF9E0" }}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            )}
            {row.group?.length > 0 && (
              <Box
                sx={{
                  backgroundColor: "#FFC218",
                  height: "30px",
                  width: "21px",
                  border: "1px solid #FDF9E0",
                  borderRadius: "6px",
                  justifySelf: "center",
                }}
              >
                <div
                  style={{
                    height: "28px",
                    width: "11px",
                    lineHeight: "28px",
                    font: "Poppins",
                    fontWeight: "600",
                    color: "#000000",
                    padding: "2px 4px",
                  }}
                >
                  {row.group?.length + 1}
                </div>
              </Box>
            )}
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            {" "}
            <Grid2
              container
              spacing={2}
              p={1.5}
              sx={{
                borderLeft: isOpen ? "1px solid #FDF9E0" : "none",
                borderBottom: isOpen ? "1px solid #FDF9E0" : "none",
              }}
            >
              <Grid2 item size={{ xs: 11 }}>
                <Grid2 container spacing={2} sx={{ alignItems: "flex-start" }}>
                  <Grid2
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 4,
                      lg: 3,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 0.5,
                      }}
                    >
                      <Grid2 container spacing={1} sx={{ width: "100%" }}>
                        <Grid2
                          item
                          size={{
                            xs: 12,
                            sm: showFields ? 6 : 12,
                            md: showFields ? 6 : 12,
                            lg: showFields ? 6 : 12,
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", color: "#FDF9E0" }}
                          >
                            {highlightText(row.name, searchQuery)}
                          </Typography>
                        </Grid2>
                        {showFields && (
                          <Grid2
                            item
                            size={{
                              xs: 12,
                              sm: 6,
                              md: 6,
                              lg: 6,
                            }}
                            sx={{
                              display: "flex",
                              justifyContent: {
                                xs: "flex-start",
                                sm: "flex-end",
                                ml: 0,
                              },
                            }}
                          >
                            {getStatusChip(
                              row?.fitCategory,
                              row?.fitPercentage
                            )}
                          </Grid2>
                        )}
                      </Grid2>

                      <Box>
                        <Tooltip title={"Mobile Number"} arrow>
                          <Box>
                            <InfoRow
                              icon={
                                <PhoneInTalkOutlinedIcon
                                  sx={{ color: "#FDF9E0B2" }}
                                />
                              }
                              label={highlightText(
                                row.userform?.mobile || "N/A",
                                searchQuery
                              )}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                      <Box>
                        <Tooltip title={"Email Address"} arrow>
                          <Box>
                            <InfoRow
                              icon={
                                <EmailOutlinedIcon
                                  sx={{ color: "#FDF9E0B2" }}
                                />
                              }
                              label={highlightText(
                                row.userform?.email || "N/A",
                                searchQuery
                              )}
                            />{" "}
                          </Box>
                        </Tooltip>
                      </Box>
                      <Box>
                        <Tooltip title={"Location"} arrow>
                          <Box>
                            <InfoRow
                              icon={
                                <LocationOnOutlinedIcon
                                  sx={{ color: "#FDF9E0B2" }}
                                />
                              }
                              label={highlightText(
                                row.userform?.location || "N/A",
                                searchQuery
                              )}
                            />{" "}
                          </Box>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.5 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-end",
                        gap: 1,
                      }}
                    >
                      <Box>
                        <Tooltip title={"Date & Time"} arrow>
                          <Box>
                            <InfoRow
                              icon={
                                <CalendarMonthOutlinedIcon
                                  sx={{ color: "#FDF9E0B2" }}
                                />
                              }
                              label={highlightText(
                                formatISTDateTime(row.time || row.date) ||
                                  "N/A",
                                searchQuery
                              )}
                            />
                          </Box>
                        </Tooltip>
                      </Box>

                      <Box>
                        <Tooltip title={"Last Company"} arrow>
                          <Box>
                            <InfoRow
                              icon={
                                <BusinessSharpIcon
                                  sx={{ color: "#FDF9E0B2" }}
                                />
                              }
                              label={highlightText(
                                row.userform?.currentCompany || "N/A",
                                searchQuery
                              )}
                            />
                          </Box>
                        </Tooltip>
                      </Box>

                      <Box>
                        <Tooltip title={"Last Role"} arrow>
                          <Box>
                            <InfoRow
                              icon={<GearIcon />}
                              label={highlightText(
                                row.userform?.role || "N/A",
                                searchQuery
                              )}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 4,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "left",
                        }}
                      >
                        <Box>{renderStatusIcon(row)}</Box>
                      </Box>
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{ color: "#FDF9E0B2", textAlign: "left" }}
                        >
                          Status
                        </Typography>
                      </Box>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#FDF9E0",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {isNaN(row.userform?.experience)
                            ? `Total experience of ${row.userform?.experience}`
                            : formatExperience(
                                parseInt(row.userform?.experience, 10)
                              )}{" "}
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#FDF9E0B2",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        Years of Experience
                      </Typography>
                    </Box>
                  </Grid2>

                  <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 3 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 3,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          maxWidth: "100%",
                        }}
                      >
                        {visibleSkills?.map((skill, index) => (
                          <Chip
                            key={index}
                            label={highlightText(skill, searchQuery)}
                            size="small"
                            variant="outlined"
                            sx={{
                              color: "#FDF9E0",
                              backgroundColor: "#1e1e1e",
                              fontWeight: 500,
                              fontSize: "12px",
                              lineHeight: "18px",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              border: "0.2px solid #FDF9E0",
                              maxWidth: "100%",
                              whiteSpace: "normal",
                            }}
                          />
                        ))}

                        {allSkills?.length > 5 && (
                          <IconButton
                            onClick={() =>
                              setOpenSkill(showSkills ? null : row.uuid)
                            }
                            sx={{
                              color: "#FDF9E0",
                            }}
                          >
                            {showSkills ? (
                              // <KeyboardArrowUpIcon fontSize="small" />
                              <span style={{ fontSize: "12px" }}>
                                View less...
                              </span>
                            ) : (
                              // <KeyboardArrowDownIcon fontSize="small" />
                              <span style={{ fontSize: "12px" }}>
                                View more...
                              </span>
                            )}
                          </IconButton>
                        )}
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#FDF9E0B2",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        Skills
                      </Typography>
                    </Box>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item size={{ xs: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: { xs: "wrap", md: "nowrap" },
                    alignItems: "center",
                  }}
                >
                  <Tooltip title="View Resume">
                    <IconButton
                      component="a"
                      href={row.fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "#FDF9E0",
                        backgroundColor: "#0BA2FF",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "#0BA2FF",
                        },
                        height: "40px",
                        width: "40px",
                      }}
                    >
                      <div
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "8px",
                        }}
                      >
                        <ResumeIcon />
                      </div>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Public Profile">
                    <IconButton
                      component="a"
                      href={`/resume-history/${row.uuid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "#FDF9E0",
                        backgroundColor: "#26801E",
                        borderRadius: "10px",
                        "&:hover": {
                          backgroundColor: "#26801E",
                        },
                        height: "40px",
                        width: "40px",
                      }}
                    >
                      <div
                        style={{
                          height: "30px",
                          width: "30px",
                          borderRadius: "8px",
                        }}
                      >
                        <ProfileIcon />
                      </div>
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid2>
            </Grid2>
          </Box>
          <Box>
            {isOpen && row.group?.length > 0 && (
              <ChildRowsLayout children={row.group} searchQuery={searchQuery} />
            )}
          </Box>
        </Box>
      </Box>
    );
  };
  const columns = [
    {
      field: "name",
      headerName: "",
      flex: 0.9,
      sortable: false,
      renderCell: ({ row }) => {
        const isOpen = openRowId === row.uuid;
        const showSkills = openSkill === row.uuid;
        const allSkills = row.userform?.primarySkill?.map(
          (skill) => skill.name
        );
        const visibleSkills = showSkills ? allSkills : allSkills.slice(0, 5);
        const showFields = tableName === "jd-ranker" ? true : false;

        return isMobile
          ? MobileView(
              row,
              isOpen,
              showSkills,
              visibleSkills,
              showFields,
              allSkills
            )
          : NormalView(
              row,
              isOpen,
              showSkills,
              visibleSkills,
              showFields,
              allSkills
            );
      },
    },
  ];

  function CustomNoRowsOverlay() {
    return (
      <Box
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.08)",
          color: "#ffffff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
          height: "100px",
          width: "100%",
        }}
      >
        <Typography variant="body2" sx={{ opacity: 0.8, fontSize: "16px" }}>
          No data available
        </Typography>
      </Box>
    );
  }

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={(row) => row.uuid}
      loading={tableLoading}
      pagination={false}
      hideFooter={true}
      hideHeader={true}
      apiRef={apiRef}
      slots={{
        noRowsOverlay: CustomNoRowsOverlay,
      }}
      autoHeight
      getRowHeight={() => "auto"}
      disableColumnMenu={true}
      disableRowSelectionOnClick
      sx={{
        borderRadius: "0px !important",
        "& .MuiDataGrid-columnHeaders": {
          display: "none",
        },
        "& .MuiDataGrid-columnHeader": {
          display: "none",
        },
        "& .MuiDataGrid-virtualScrollerRenderZone": {
          marginTop: "0px !important",
        },
        "& .MuiDataGrid-main": {
          paddingTop: "0px !important",
        },
        "& .MuiDataGrid-row": {
          outlineOffset: "-3px",
        },
        "& .MuiDataGrid-cell:not(.MuiDataGrid-cellCheckbox):first-of-type": {
          pl: "0px",
        },
        "& .MuiDataGrid-cell:last-of-type": {
          pr: "10px",
        },
        "& .MuiDataGrid-columnHeaderCheckbox, & .MuiDataGrid-cellCheckbox ": {
          maxWidth: "45px !important",
          minWidth: "45px !important",
        },
      }}
    />
  );
}

export default CollapsibleTableNew;
